const API =
  "https://us-central1-urbanhomey-363dc.cloudfunctions.net/logDownloadAnalytics";

export async function logDownloadPageVisit(device) {
  try {
    const ua = navigator.userAgent;
    const referrer = document.referrer;

    // ------------------------
    // Session
    // ------------------------

    let sessionId = sessionStorage.getItem("uh_session");

    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 10)}`;

      sessionStorage.setItem("uh_session", sessionId);
    }

    // ------------------------
    // Browser
    // ------------------------

    let browser = "other";

    if (ua.includes("Edg")) browser = "edge";
    else if (ua.includes("OPR")) browser = "opera";
    else if (ua.includes("Firefox")) browser = "firefox";
    else if (ua.includes("Chrome")) browser = "chrome";
    else if (ua.includes("Safari")) browser = "safari";

    // ------------------------
    // Platform
    // ------------------------

    let platform = "other";

    if (ua.includes("Instagram")) {
      platform = "instagram";
    } else if (
      ua.includes("FBAN") ||
      ua.includes("FBAV")
    ) {
      platform = "facebook";
    } else if (ua.includes("WhatsApp")) {
      platform = "whatsapp";
    }

    // ------------------------
    // OS
    // ------------------------

    let os = "Other";

    if (/Android/i.test(ua)) os = "Android";
    else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
    else if (ua.includes("Windows")) os = "Windows";
    else if (ua.includes("Mac")) os = "macOS";
    else if (ua.includes("Linux")) os = "Linux";

    // ------------------------
    // Campaign
    // ------------------------

    const params = new URLSearchParams(window.location.search);

    const body = {
      sessionId,

      device,
      os,
      browser,
      platform,

      campaign: params.get("source") || "direct",

      utmSource: params.get("utm_source"),
      utmMedium: params.get("utm_medium"),
      utmCampaign: params.get("utm_campaign"),
      utmContent: params.get("utm_content"),

      isFirstVisit:
        !localStorage.getItem("uh_download_visit"),

      language: navigator.language,

      timezone:
        Intl.DateTimeFormat().resolvedOptions().timeZone,

      userAgent: ua,

      cookieEnabled: navigator.cookieEnabled,

      online: navigator.onLine,

      touchSupport: navigator.maxTouchPoints,

      screenWidth: window.screen?.width ?? null,

      screenHeight: window.screen?.height ?? null,

      viewportWidth: window.innerWidth,

      viewportHeight: window.innerHeight,

      orientation:
        window.screen?.orientation?.type ?? null,

      colorDepth:
        window.screen?.colorDepth ?? null,

      pixelRatio:
        window.devicePixelRatio ?? 1,

      networkType:
        navigator.connection?.effectiveType ?? null,

      downlink:
        navigator.connection?.downlink ?? null,

      pageTitle: document.title,

      hostname: window.location.hostname,

      pathname: window.location.pathname,

      url: window.location.href,

      referrer,

      clientTimestamp: new Date().toISOString(),
    };

    console.log("📤 Sending analytics...");
    console.log(body);

    const response = await fetch(API, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    console.log("Response Status:", response.status);

    if (body.isFirstVisit) {
      localStorage.setItem(
        "uh_download_visit",
        "true"
      );
    }

    return response.ok;
  } catch (e) {
    console.error("Analytics Error:", e);
    return false;
  }
}